export class NotificationService {
  private static instance: NotificationService;
  private permission: NotificationPermission = 'default';

  private constructor() {
    this.checkPermission();
  }

  static getInstance(): NotificationService {
    if (!NotificationService.instance) {
      NotificationService.instance = new NotificationService();
    }
    return NotificationService.instance;
  }

  private checkPermission() {
    if ('Notification' in window) {
      this.permission = Notification.permission;
    }
  }

  async requestPermission(): Promise<boolean> {
    if (!('Notification' in window)) {
      console.log('This browser does not support notifications');
      return false;
    }

    if (Notification.permission === 'granted') {
      return true;
    }

    if (Notification.permission !== 'denied') {
      const permission = await Notification.requestPermission();
      this.permission = permission;
      return permission === 'granted';
    }

    return false;
  }

  async showNotification(title: string, options?: NotificationOptions): Promise<void> {
    if (!('Notification' in window)) {
      return;
    }

    if (this.permission !== 'granted') {
      const granted = await this.requestPermission();
      if (!granted) return;
    }

    const notification = new Notification(title, {
      icon: '/logo-icon-app.svg',
      badge: '/logo-icon-app.svg',
      ...options,
    });

    // Auto close after 10 seconds
    setTimeout(() => {
      notification.close();
    }, 10000);

    return new Promise((resolve) => {
      notification.onclick = () => {
        window.focus();
        notification.close();
        resolve();
      };
    });
  }

  showJobCompleted(projectName: string, jobId: string) {
    this.showNotification('Job Completed', {
      body: `Your analysis "${projectName}" completed.`,
      tag: `job-${jobId}`,
      requireInteraction: false,
      data: { jobId },
    });
  }

  showJobFailed(projectName: string, jobId: string, error?: string) {
    this.showNotification('Job Failed', {
      body: `Your analysis "${projectName}" failed${error ? `: ${error}` : '.'}`,
      tag: `job-${jobId}`,
      requireInteraction: false,
      data: { jobId },
    });
  }
}

export const notificationService = NotificationService.getInstance();